import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
@Injectable({
    providedIn: 'root',
})
export class GuidCheck implements CanActivate {
    constructor(private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        let pattern = new RegExp('^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$', 'i');
        if (route.queryParamMap.get('organizationId') && route.params.id) {
            if (pattern.test(route.queryParamMap.get('organizationId')) && pattern.test(route.params.id)) {
                return true;
            } else {
                this.router.navigate(['/404']);
            }
        } else if (pattern.test(route.queryParamMap.get('organizationId')) || pattern.test(route.params.id)) {
            return true;
        } else {
            this.router.navigate(['/404']);
        }

        return true;
    }
}
